export default function PassengerForm({
  msg,
  number,
  title,
  selectable,
  isChecked,
  onCheck,
  isView,
  register,
  errors,
  prefix,
  ageGroup,
  index,
  nameFillLater,
  nameCheckinNo,
  nameFirstName,
  nameLastName,
  nameGender,
  nameDateOfBirth,
  nameNA,
  nameAge,
  nameCountry,
  nameNationality,
  nameIdPassportNo,
  nameHotelAddress,
  nameVoucherNo,
  genderOption,
  countryOption=[],
  nationalityOption,
  onChangeDateOfBirth,
  onChangeNA,
  onValidateAge,
  onValidateIdPassportNo,
  isDisabledAge,
  isDisabledDateOfBirth,
  isDisabledFirstName,
  isDisabledLastName,
  isCheckedNA,
  defaultGender,
  onChangeGender,
  onChangeFillLater,
  isCheckedFillLater,
}) {
  const registerName = (name) => `${prefix}.${ageGroup}.${index}.${name}`;
  return (
    <details className="passenger_form">
      <summary className="passenger_form_header">
        <span>{`${number}. ${title}`}</span>
        <input
          hidden={!selectable}
          type="checkbox"
          checked={isChecked}
          onChange={onCheck}
        />
      </summary>
      <div className="passenger_form_body">
        <div className="_input_text_select span-3">
          <label>{`${msg.firstname} *`}</label>
          <input
            placeholder={msg.first_name}
            {...register(registerName(nameFirstName), {
              required: !isCheckedFillLater,
            })}
            className={
              errors?.[prefix]?.[ageGroup]?.[index]?.[nameFirstName]
                ? "_data_invalid"
                : ""
            }
            disabled={isView || isDisabledFirstName || isCheckedFillLater}
          />
          <div className="extra_checkbox">
            <input
              type="checkbox"
              {...register(registerName(nameFillLater), {
                onChange: onChangeFillLater,
              })}
              checked={isCheckedFillLater}
              disabled={isView}
            />
            <label>{msg.fill_later}</label>
          </div>
        </div>
        <div className="_input_text_select span-3">
          <label>{`${msg.lastname} *`}</label>
          <input
            placeholder={msg.last_name}
            {...register(registerName(nameLastName), {
              required: !isCheckedFillLater,
            })}
            className={
              errors?.[prefix]?.[ageGroup]?.[index]?.[nameLastName]
                ? "_data_invalid"
                : ""
            }
            disabled={isView || isDisabledLastName || isCheckedFillLater}
          />
        </div>
        <div className="_input_text_select extra_radio span-2">
          <label>{`${msg.gender}`}</label>
          <div>
            {genderOption.map((el, index) => (
              <div
                key={`${number}.${el.value}.${index}`}
                className="_input_radio"
              >
                <input
                  type="radio"
                  {...register(registerName(nameGender), {
                    onChange: onChangeGender,
                  })}
                  value={el.value}
                  checked={`${el.value}` === `${defaultGender}`}
                  disabled={isView}
                />
                <label>{el.label}</label>
              </div>
            ))}
          </div>
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg.date_of_birth}`}</label>
          <input
            type="date"
            placeholder={msg.date_of_birth}
            {...register(registerName(nameDateOfBirth), {
              onChange: onChangeDateOfBirth,
            })}
            disabled={isView || isDisabledDateOfBirth}
            max={new Date().toISOString().split("T")[0]}
          />
          {/* <div className="extra_checkbox">
            <input
              type="checkbox"
              {...register(registerName(nameNA), {
                onChange: onChangeNA,
              })}
              checked={isCheckedNA}
              disabled={isView}
            />
            <label>{msg["n/a"]}</label>
          </div> */}
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg.age}`}</label>
          <input
            placeholder={msg.age}
            {...register(registerName(nameAge), {
              validate: onValidateAge,
            })}
            className={
              errors?.[prefix]?.[ageGroup]?.[index]?.[nameAge]
                ? "_data_invalid"
                : ""
            }
            disabled={isView || isDisabledAge || true}
          />
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg.country}`}</label>
          <select {...register(registerName(nameCountry))} disabled={isView}>
            <option value="" label={msg.country} />
            {countryOption.map((el) => (
              <option key={el.value} value={el.value} label={el.label} />
            ))}
          </select>
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg.nationality}`}</label>
          <select
            {...register(registerName(nameNationality))}
            disabled={isView}
          >
            <option value="" label={msg.nationality} />
            {nationalityOption.map((el) => (
              <option key={el.value} value={el.value} label={el.label} />
            ))}
          </select>
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg["id/passport_no"]}`}</label>
          <input
            placeholder={msg["id/passport_no"]}
            {...register(registerName(nameIdPassportNo), {
              validate: onValidateIdPassportNo,
            })}
            className={
              errors?.[prefix]?.[ageGroup]?.[index]?.[nameIdPassportNo]
                ? "_data_invalid"
                : ""
            }
            disabled={isView}
          />
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg["hotel/address"]}`}</label>
          <input
            placeholder={msg["hotel/address"]}
            {...register(registerName(nameHotelAddress))}
            disabled={isView}
          />
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg.voucher_no}`}</label>
          <input
            placeholder={msg.voucher_no}
            {...register(registerName(nameVoucherNo))}
            disabled={isView}
          />
        </div>
        <div className="_input_text_select span-2">
          <label>{`${msg.checkin_no} *`}</label>
          <input
            placeholder={msg.checkin_no}
            {...register(registerName(nameCheckinNo), {
              required: true,
            })}
            className={
              errors?.[prefix]?.[ageGroup]?.[index]?.[nameCheckinNo]
                ? "_data_invalid"
                : ""
            }
            disabled={isView}
          />
        </div>
      </div>
    </details>
  );
}
